<script setup>
import { useRoute, useRouter } from 'vue-router'
import { onMounted } from 'vue'
import { periodoSelecionadoPhp } from '@/store/periodoStore'

const route = useRoute()
const router = useRouter()

// Classes para os botões
const activeClass =
  'bg-[#fb5e7f] text-white px-6 py-2 text-sm font-semibold transition'
const inactiveClass =
  'bg-white text-gray-800 px-6 py-2 text-sm font-semibold hover:bg-gray-100 transition'

// Atualiza a URL ao clicar
const selecionarPeriodo = (valor) => {
  periodoSelecionadoPhp.value = valor
  router.replace({ query: { ...route.query, periodo: valor } })
}

// Verifica se já veio pela URL
onMounted(() => {
  const periodoURL = route.query.periodo
  if (['1', '12', '24'].includes(periodoURL)) {
    periodoSelecionadoPhp.value = periodoURL
  }
})
</script>

<template>
  <section class="relative z-0 bg-cover bg-center text-white text-center pt-44 pb-60 px-4">
    <h1 class="text-3xl md:text-5xl font-extrabold mb-4">HOSPEDAGEM PHP</h1>
    <p class="text-lg md:text-xl mb-8">
      Hospedagem para sites em PHP e HTML, Wordpress, Joomla, Magento entre outros
    </p>

    <!-- Botões de período -->
    <div class="inline-flex rounded-lg overflow-hidden shadow-lg">
      <button
        @click="selecionarPeriodo('1')"
        :class="periodoSelecionadoPhp === '1' ? activeClass : inactiveClass"
      >
        1 mês
      </button>
      <button
        @click="selecionarPeriodo('12')"
        :class="periodoSelecionadoPhp === '12' ? activeClass : inactiveClass"
      >
        12 meses
      </button>
      <button
        @click="selecionarPeriodo('24')"
        :class="periodoSelecionadoPhp === '24' ? activeClass : inactiveClass"
      >
        24 meses
      </button>
    </div>
  </section>
</template>
